<template>
  <div class="row noticiashome vigrid" v-show="isvisible">
    <div class="small-12 columns">
      <div class="row">
        <div class="columns flex2">
          <div data-open="imagePopup"
            @click="() => setCurrentImage(al5a)"
            class="icon-play ajaxIframe">
            <div :style="{ backgroundImage: 'url(' + al5a + ')' }"
              class="videoGallery_image-background lazy">
            </div>
            <div class="module-videogallery_item_title">
              <span>{{ $t("UMA_LANG_SASUMA_CALL1") }}</span>
            </div>
          </div>
        </div>
        <div class="columns">
          <div data-open="imagePopup"
            @click="() => setCurrentImage(alojamento2)"
            class="icon-play ajaxIframe">
            <div :style="{ backgroundImage: 'url(' + alojamento2 + ')' }"
              class="videoGallery_image-background lazy">
            </div>
            <div class="module-videogallery_item_title">
              <span>{{ $t("UMA_LANG_SASUMA_CALL2") }}</span>
            </div>
          </div>
        </div>
        <div class="columns">
          <div data-open="imagePopup"
            @click="() => setCurrentImage(Poster11)"
            class="icon-play ajaxIframe">
            <div :style="{ backgroundImage: 'url(' + Poster11 + ')' }"
              class="videoGallery_image-background lazy">
            </div>
            <div class="module-videogallery_item_title">
              <span>{{ $t("UMA_LANG_SASUMA_CALL3") }}</span>
            </div>
          </div>
        </div>
        <div class="columns flex2">
          <div data-open="imagePopup"
            @click="() => setCurrentImage(alojamento1)"
            class="icon-play ajaxIframe">
            <div
              :style="{ backgroundImage: 'url(' + alojamento1 + ')' }"
              class="videoGallery_image-background lazy">
            </div>
            <div class="module-videogallery_item_title">
              <span>{{ $t("UMA_LANG_SASUMA_CALL4") }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="columns flex2">
          <div data-open="imagePopup"
            @click="() => setCurrentImage(alojamento3)"
            class="icon-play ajaxIframe">
            <div
              :style="{ backgroundImage: 'url(' + alojamento3 + ')' }"
              class="videoGallery_image-background lazy">
            </div>
            <div class="module-videogallery_item_title">
              <span>{{ $t("UMA_LANG_SASUMA_CALL5") }}</span>
            </div>
          </div>
        </div>

        <div class="columns">
          <div href="" title="" data-open="imagePopup"
            @click="() => setCurrentImage(Poster10)"
            class="icon-play ajaxIframe">
            <div
              :style="{ backgroundImage: 'url(' + Poster10 + ')' }"
              class="videoGallery_image-background lazy">
            </div>
            <div class="module-videogallery_item_title">
              <span>{{ $t("UMA_LANG_SASUMA_CALL6") }}</span>
            </div>
          </div>
        </div>
        <div class="columns">
          <div href="" title="" data-open="imagePopup"
            @click="() => setCurrentImage(al3a)"
            class="icon-play ajaxIframe">
            <div :style="{ backgroundImage: 'url(' + al3a + ')' }"
              class="videoGallery_image-background lazy">
            </div>
            <div class="module-videogallery_item_title">
              <span>{{ $t("UMA_LANG_SASUMA_CALL7") }}</span>
            </div>
          </div>
        </div>
        <div class="columns flex2">
          <div data-open="imagePopup"
            @click="() => setCurrentImage(al4a)"
            class="icon-play ajaxIframe">
            <div :style="{ backgroundImage: 'url(' + al4a + ')' }" 
              class="videoGallery_image-background lazy">
            </div>
            <div class="module-videogallery_item_title">
              <span>{{ $t("UMA_LANG_SASUMA_CALL8") }}</span>
            </div>
          </div>
        </div>

      </div>
      <div id="modalrevealteste"></div>
      <div class="reveal bibreveal" id="imagePopup" data-reveal>
        <button class="close-button" data-close="" aria-label="Close modal" type="button">
          <span aria-hidden="true">×</span>
        </button>
        <img :src="currentImage">
      </div>
    </div>
  </div>
</template>

<script>
import al5a from "@/assets/images/al5a.jpg";
import alojamento2 from "@/assets/images/alojamento2.jpg";
import Poster11 from "@/assets/images/Poster-11.jpg";
import alojamento1 from "@/assets/images/alojamento1.jpg";
import alojamento3 from "@/assets/images/alojamento3.jpg";
import Poster10 from "@/assets/images/Poster-10.jpg";
import al3a from "@/assets/images/al3a.jpg";
import al4a from "@/assets/images/al4a.jpg";

import $ from 'jquery';
import 'foundation-sites';
import { ref, onMounted, onUnmounted, onBeforeUnmount, nextTick } from "vue";

export default {
  setup() {

    const currentImage = ref('');

    const setCurrentImage = (newImage) => {
      currentImage.value = newImage
    }

    onMounted(() => {
      nextTick(() => {
        $(".bibreveal").foundation();
        window.addEventListener('resize', checkWindowSize);
        $(".bibreveal").on('closed.zf.reveal',setImageToEmpty)
        checkWindowSize()
      })
    })

    const isvisible = ref(true);

    const setImageToEmpty = () => {
      currentImage.value = '';
    }

    const checkWindowSize = () => {
      if (window.innerWidth < 1025) { 
        $(".bibreveal").foundation('close'); 
        isvisible.value = false;
      } else {
        if(currentImage.value != ''){
          $(".bibreveal").foundation('open');
        }
        isvisible.value = true;
      }
    }

    onBeforeUnmount(() => {
      $(".bibreveal").foundation('close'); 
      $(".bibreveal").off('closed.zf.reveal',setImageToEmpty)
    })

    onUnmounted(() => {
      isvisible.value = false;
      window.removeEventListener('resize', checkWindowSize);
    });

    return {
      isvisible,
      setCurrentImage,
      currentImage,
      al5a,
      alojamento2,
      Poster11,
      alojamento1,
      alojamento3,
      Poster10,
      al3a,
      al4a
    }
  }
}
</script>

<style lang="scss" scoped>
.fullopacityvideolayer {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  opacity: 0;
  transition: -webkit-transform .6s, opacity .6s;
  z-index: -1000;
  overflow: hidden;
  background: #0b0b0b;
}

.videowrapper {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: -1000;
  opacity: 0;
  transition: -webkit-transform .6s, opacity .6s;
  max-width: 100%;
}


.row.vigrid,
.row.vigrid .row {
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
}

.row.vigrid .columns {
  padding: 0;
}

.flex2 {
  flex: 2;
}

.vigrid a {
  position: relative;
  width: 100%;
  background-size: cover;
  background-position: center;
  display: block;
}

.vigrid .icon-play.ajaxIframe {
  position: relative;
  width: 100%;
  padding-top: 108%;
  background-size: cover;
  background-position: center;
  display: block;
  overflow: hidden;
}

.vigrid .icon-play.ajaxIframe .videoGallery_image-background,
.vigrid .videolink .videoGallery_image-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: 50%;
  transition: transform .4s ease-out;
}

.flex2 a,
.flex2>div {
  padding-top: 54% !important;
}

.vigrid .ajaxIframe:hover .videoGallery_image-background {
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
}

.vigrid .module-videogallery_item_title {
  display: flex;
  justify-content: center;
  align-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 1em;
  right: 1em;
  letter-spacing: -5px;
  z-index: 3;
  font-family: "Montserrat";
  font-size: 1.3333em;
  line-height: 32px;
  -webkit-opacity: 0;
  -moz-opacity: 0;
  opacity: 0;
  text-align: center;
  transform: translate3d(0, -10px, 0);
  -webkit-transform: translate3d(0, -10px, 0);
  -ms-transform: translate3d(0, -10px, 0);
  -webkit-transition: -webkit-transform .4s ease-out, opacity .3s ease-out;
  transition: transform .4s ease-out, opacity .3s ease-out;
}

.vigrid .ajaxIframe:hover .module-videogallery_item_title,
.vigrid .videolink:hover .module-videogallery_item_title {
  -webkit-opacity: 1;
  -moz-opacity: 1;
  opacity: 1;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
}


.vigrid .videolink:before {
  position: absolute;
  color: #fff;
  top: 0;
  left: 0;
  padding: 1px;
  font-size: 65px;
  z-index: 3;
  transform: scale(.38);
  transition: opacity .3s ease-out, transform .3s ease-out;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.vigrid .videolink:hover:before {
  transform: scale(.55);
  -webkit-opacity: 0;
  -moz-opacity: 0;
  opacity: 0;
}


.vigrid .module-videogallery_item_title span {
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0;
  color: #fff;
}

.vigrid .ajaxIframe:after,
.vigrid .icon-play.ajaxIframe:after,
.vigrid .videolink:after {
  -webkit-transition: opacity .5s ease-in-out;
  transition: opacity .5s ease-in-out;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(93, 91, 111, 0.93);
  opacity: 0.3;
}

.vigrid .ajaxIframe:hover:after,
.vigrid .icon-play.ajaxIframe:hover:after,
.vigrid .videolink:hover:after {
  opacity: 0.6;
}


/*copiado e para revisÃƒÂ£o*/
/*bigvideo*/
.videowrapper {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: -1000;
  opacity: 0;
  transition: -webkit-transform .6s, opacity .6s;
  max-width: 100%;
}

.videowrapper.show {
  z-index: 999999;
  opacity: 1;
  transition: -webkit-transform .6s, opacity .6s;
}

.row.frameholder {
  max-width: 100%;
  max-height: 100vh;
  margin-left: 0;
  margin-right: 0;
  padding-top: 95px;
  padding-bottom: 50px;
}


/*Animates video show and video disapear*/
.videocontent {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin: 0 auto;
  text-align: left;
  max-width: 1600px;
  z-index: 1045;
  line-height: 0;
  width: 100%;
  max-height: 100%;
  overflow: visible !important;
  transition: transform .6s, opacity .6s;
  transform: translateY(50px);
  opacity: 0;
  padding-top: 50px;
}

.videowrapper.show .videocontent {
  opacity: 1;
  transform: translateY(0);
  transition: transform .6s, opacity .6s;
  overflow: visible !important;
}

.videowrapper.close .videocontent {
  opacity: 0;
  transform: translateY(-50px);
  transition: transform .6s, opacity .6s;
}

/*Animates video show and video disapear*/

.scaler {
  width: 100%;
  height: 0;
  overflow: visible;
  padding-top: 56.25%;
}

.videocontent iframe {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-shadow: 0 0 8px rgba(0, 0, 0, .6);
  background: #000;
  font-size: 28px;
}

.videocontent .b-container {
  position: absolute;
  right: 0;
  top: -40px;
  width: 25px;
  height: 22px;
}

.fullopacityvideolayer {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  position: fixed;
  opacity: 0;
  transition: -webkit-transform .6s, opacity .6s;
  z-index: -1000;
  overflow: hidden;
  background: #0b0b0b;
}

.fullopacityvideolayer.show {
  display: block;
  opacity: .6;
  transition: -webkit-transform .6s, opacity .6s;
  z-index: 1042;
}

.closebtn {
  position: absolute;
  top: -47px;
  right: 0;
  color: white;
  font-size: 28px;
}

.videocontent .closebtn {
  right: 25px;
}

.mfp-iframe-scaler {
  width: 100%;
  height: 0;
  overflow: hidden;
  padding-top: 56.25%;
}

.hidden-bullets {
  opacity: 0;
}


#imagePopup {
  width: auto;
  max-width: 40%;
  display: inline-block;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 130px !important;
  padding: 0;
  display: inline-block;
  margin: 0 auto;
}

#imagePopup .close-button{
  background: white;
  padding: 7px;
  top: 0;
  right: 0;
}

#modalrevealteste{
  text-align: center;
}
/*
@media (max-width: 1024px) {
  #algrid,#imagePopup{
    display: none !important;
  }
}*/
</style>